function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Current",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "3.1-VotingPeoples-Big-sidebar-+-Flow",
  transform: "translate(-21.000000, -865.000000)",
  fill: "#9F9AAD"
}, /*#__PURE__*/React.createElement("g", {
  id: "Sidebar-/-Opened"
}, /*#__PURE__*/React.createElement("g", {
  id: "Logout",
  transform: "translate(21.000000, 864.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "iconcs-/-ic_logout",
  transform: "translate(0.000000, 1.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "logout-(1)",
  transform: "translate(0.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.03685641,18.8220339 L3.76368707,18.8220339 C2.33062071,18.8220339 1.16786327,17.6694915 1.16786327,16.2584746 L1.16786327,3.70762712 C1.16786327,2.29237288 2.33491133,1.1440678 3.76368707,1.1440678 L9.12266876,1.1440678 C9.4444651,1.1440678 9.70190217,0.889830508 9.70190217,0.572033898 C9.70190217,0.254237288 9.4444651,0 9.12266876,0 L3.76368707,0 C1.69131865,0 0.00939645309,1.66525424 0.00939645309,3.70762712 L0.00939645309,16.2584746 C0.00939645309,18.3050847 1.69560927,19.9661017 3.76368707,19.9661017 L9.03685641,19.9661017 C9.35865275,19.9661017 9.61608982,19.7118644 9.61608982,19.3940678 C9.61608982,19.0762712 9.35436213,18.8220339 9.03685641,18.8220339 Z",
  id: "Path",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.1375858,9.58050847 L15.4562357,5.94491525 C15.228833,5.72033898 14.8641304,5.72033898 14.6367277,5.94491525 C14.4093249,6.16949153 14.4093249,6.52966102 14.6367277,6.75423729 L17.3312357,9.41525424 L5.57923341,9.41525424 C5.25743707,9.41525424 5,9.66949153 5,9.98728814 C5,10.3050847 5.25743707,10.559322 5.57923341,10.559322 L17.3312357,10.559322 L14.6367277,13.220339 C14.4093249,13.4449153 14.4093249,13.8050847 14.6367277,14.029661 C14.7482838,14.1398305 14.8984554,14.1991525 15.0443364,14.1991525 C15.1902174,14.1991525 15.340389,14.1440678 15.4519451,14.029661 L19.1332952,10.3940678 C19.3649886,10.1652542 19.3649886,9.80084746 19.1375858,9.58050847 Z",
  id: "Path",
  fillRule: "nonzero"
})))))));

function SvgIcLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLogout);
export default __webpack_public_path__ + "static/media/ic-logout.66da4996.svg";
export { ForwardRef as ReactComponent };